// src/firebaseConfig.js

import { initializeApp }   from "firebase/app";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getAnalytics }    from "firebase/analytics";
import { getAuth }         from "firebase/auth";
import { getFirestore }    from "firebase/firestore";
import { getFunctions }    from "firebase/functions";
import { getStorage }      from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDxzzuRJ1H2gUMZHpS3dYocEuVDlcZGwA8",
  authDomain: "micgro-manager.firebaseapp.com",
  projectId: "micgro-manager",
  storageBucket: "micgro-manager.firebasestorage.app",
  messagingSenderId: "942785260067",
  appId: "1:942785260067:web:e81d91099a43b432ba5f96",
  measurementId: "G-GZM46THV71"
};

const app = initializeApp(firebaseConfig);

initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider("6LfBCmEsAAAAAK8wAq25VHIq9QI5oBWpXlAcSDPl"),
  isTokenAutoRefreshEnabled: true,
});

export const auth      = getAuth(app);
export const db        = getFirestore(app);
export const functionsClient = getFunctions(app);
export const storage   = getStorage(app);

// only initialize analytics in a browser environment
export const analytics = typeof window !== "undefined"
  ? getAnalytics(app)
  : null;
